export default "__VITE_ASSET__CLaw05Et__"